import { useTrackTranscription } from "@livekit/components-react";

import { View, StyleSheet } from "react-native";
import CustomText from "../../components/common/general/CustomText/CustomText";
import { useVoiceAssistant } from "@livekit/components-react";
import { ScrollView } from "react-native-gesture-handler";

function SimpleVoiceAssistant() {
  const { audioTrack } = useVoiceAssistant();
  const { segments } = useTrackTranscription(audioTrack);

  return (
    <View style={styles.transcriptContainer}>
      <ScrollView style={styles.scrollView}>
        {segments.length > 0 && (
          <CustomText
            text={segments[segments.length - 1].text}
            size="xl"
            style={styles.transcriptText}
            useTranslationText={false}
          />
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  transcriptContainer: {
    flex: 1,
    padding: 20,
    justifyContent: "center",
    alignItems: "center",
  },
  transcriptText: {
    width: 425,
    textAlign: "center",
    color: "#667085",
  },
  scrollView: {
    height: 20,
  },
});

export default SimpleVoiceAssistant;
